import { isSameInterval } from '@wilson/utils';
import type { ActivityTemplate } from '../activities/activity-template';
import { SeriesRuleType } from '../series-rule/series-rule';
import { ServiceSeries } from '../services/serviceSeries';
import { WeekDaysEnum } from '../services/weekDays';
import { ShiftSeriesV2OverviewResponseEntry } from '../shift-series-v2/shift-series-v2';

export class SeriesRuleV2 {
  constructor(
    public id: string,
    public startDate: string,
    public endDate: string,
    public frequency: SeriesRuleV2Frequency,
    public interval: number,
    public weekdays: WeekDaysEnum[],
    public type: SeriesRuleType,
    public name: string,
    public comment: string,
    public shiftSeriesId?: string,
    public serviceSeriesId?: string,
    public activityTemplateId?: string,
    public shiftSeries?: ShiftSeriesV2OverviewResponseEntry,
    public serviceSeries?: ServiceSeries,
    public activityTemplate?: ActivityTemplate,
  ) {}

  static areSamePeriod(left: SeriesRuleV2, right: SeriesRuleV2): boolean {
    return isSameInterval(
      { start: new Date(left.startDate), end: new Date(left.endDate) },
      { start: new Date(right.startDate), end: new Date(right.endDate) },
    );
  }
}

export enum SeriesRuleV2Frequency {
  Yearly = 'yearly',
  Monthly = 'monthly',
  Weekly = 'weekly',
  Daily = 'daily',
  Hourly = 'hourly',
  Minutely = 'minutely',
  Secondly = 'secondly',
}
